import InfiniteScrollList from "../../../../../common/infinite-scroll-list";
import ConfigService from "../../../../../../services/ConfigService";
import JWTClient from "../../../../../../services/JWTClient";
import ChatService from "../../../../../../services/ChatService";
import ChatListItem from "../chat-list-item";
import ModuleInfoProvider from "../../../../../../services/ModuleInfoProvider";

export default class ChatInfiniteScrollList extends InfiniteScrollList {
    emptyStateMessage = 'chat.list.empty';
    chatDomain = '';

    constructor(props) {
        super(props);
        this.chatDomain = ModuleInfoProvider.getModuleWebServiceUrl('chat');
        this.state.page = 1;
    }

    static defaultProps = {
        onChatClick: () => {}
    };

    componentDidMount() {
        this.getNext();
        ChatService.observable.subscribe(this.refresh);
    }

    componentWillUnmount() {
        ChatService.observable.unsubscribe(this.refresh);
    }

    renderItem = (item) => (
        <ChatListItem item={item} onClick={() => this.props.onChatClick(item)} />
    );

    getRefreshRequest = () => {
        const limit = this.state.list.length;
        return JWTClient.fetch(this.chatDomain + '/chats?sortBy=lastMessage&direction=desc&page=1&limit=' + limit);
    };

    getNextRequest = () => {
        return JWTClient.fetch(this.chatDomain + '/chats?sortBy=lastMessage&direction=desc&limit=20&page=' + this.state.page)
            .then(res => {
                this.setState({page: (this.state.page || 1) + 1});
                return res;
            });
    };
}


// WEBPACK FOOTER //
// ./components/sections/personal-area/sections/chat/chat-infinite-scroll-list/index.js